// Toggle collapse/expand for Price Features tables
(function () {
  function setupItem(item) {
    var toggleBtn = item.querySelector('.price-features_header_right');
    if (!toggleBtn) return;

    var content = item.querySelector('.price-features_content');
    if (!content) return;

    // Set initial height for smooth animation (default expanded)
    try {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';
    } catch (e) {}

    toggleBtn.setAttribute('role', 'button');
    toggleBtn.setAttribute('tabindex', '0');
    toggleBtn.setAttribute('aria-expanded', 'true');

    function collapse() {
      item.classList.add('collapsed');
      toggleBtn.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
    }

    function expand() {
      item.classList.remove('collapsed');
      toggleBtn.setAttribute('aria-expanded', 'true');
      try {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.opacity = '1';
      } catch (e) {}
    }

    // Click toggle
    toggleBtn.addEventListener('click', function () {
      if (item.classList.contains('collapsed')) {
        expand();
      } else {
        collapse();
      }
    });

    // Keyboard accessibility: Enter / Space
    toggleBtn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleBtn.click();
      }
    });

    // Recompute height on resize (only when expanded)
    var resizeTimer;
    window.addEventListener('resize', function () {
      if (item.classList.contains('collapsed')) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        try {
          content.style.maxHeight = content.scrollHeight + 'px';
        } catch (e) {}
      }, 100);
    });
  }

  function init() {
    var items = document.querySelectorAll('.price-features_tables_item');
    items.forEach(setupItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();